import React, { FunctionComponent } from "react";
import styles from "./Spots.module.scss";
import SpotsProps from "./SpotsProps.interface";

import Spot from "./components/Spot/Spot";

import combineClasses from "helpers/combine-classes";
import getWrapperClasses from "blocks/helpers/getWrapperClasses";
import useWrapperStyles from "blocks/hooks/useWrapperStyles";
import useBoxWrap from "blocks/hooks/useBoxWrap";
import BackgroundMedia from "components/BackgroundMedia/BackgroundMedia";
import useSplitBackground from "blocks/hooks/useSplitBackground";
import useAnchor from "blocks/hooks/useAnchor";
import setStyles from "./helpers/setStyles";

const Spots: FunctionComponent<SpotsProps> = (props): JSX.Element => {
    const wrapperClasses = getWrapperClasses(props.settings);
    const wrapperStyles = useWrapperStyles(props.settings);
    const [boxWrapClasses, boxWrapStyles] = useBoxWrap(props.settings.cardBoxWrap);

    const { containerStyles, containerClasses } = setStyles(props.settings, styles);
    const identifier = useAnchor(props.settings.anchorMenuLabel);
    const { splitClasses, splitStyles } = useSplitBackground(props);

    return (
        <section className={combineClasses(styles.wrapper, ...containerClasses, ...wrapperClasses, ...boxWrapClasses)} style={{ ...wrapperStyles, ...containerStyles, ...boxWrapStyles, ...splitStyles }} id={identifier}>
            <div className={combineClasses(styles.container, ...splitClasses)}>
                {/* Spots */}
                {props.content.spots && props.content.spots.length > 0 ? (
                    <div className={styles.list}>
                        {props.content.spots.map((item, index) => {
                            return (
                                <Spot key={index} {...item} length={props.content?.spots?.length} cardSize={props.settings.cardSize} boxWrap={props.settings.cardBoxWrap} imageCrop={props.settings.imageCrop} />
                            );
                        })}
                    </div>
                ) : null}
            </div>

            {props.settings.backgroundMedia?.[0] && props.settings.backgroundMedia.length > 0 ? (
                <BackgroundMedia key={props.contentUdi} {...props.settings.backgroundMedia[0]} />
            ) : null}
        </section>
    );
};

export default Spots;